import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { RevenueRecognitionStore } from '../stores/revenueRecognitionStore';

export const useRevenueRecognitionStore = () =>
  useContext<{
    revenueRecognitionStore: RevenueRecognitionStore;
  }>(StoreContext);
